export default __webpack_public_path__ + "c22a05a5d3512d714eb263a9d451f008.png";